"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndoManager = void 0;
const lodash_1 = require("lodash");
class UndoManager {
    constructor(size) {
        this.index = -1;
        this.history = [];
        this.debouncedPushState = (0, lodash_1.debounce)(this.pushState, 100).bind(this);
        this.size = size;
        this.history = [];
    }
    getUndoStep() {
        return this.index;
    }
    getRedoStep() {
        return this.history.length - this.index - 1;
    }
    init(initData) {
        this.index = -1;
        this.history = [];
        this.pushState(initData);
    }
    pushState(data) {
        const it = this.history[this.index];
        if (it && (0, lodash_1.isEqual)(it.data, data))
            return; // 重复，无需 pushState
        if (this.history.length === this.size) {
            this.history = this.history.slice(1);
        }
        this.history.length = this.index + 1;
        this.history.push({
            data: Object.freeze((0, lodash_1.cloneDeep)(data)),
        });
        this.index = this.history.length - 1;
    }
    undo() {
        let toRet = null;
        if (this.index > 0) {
            this.index -= 1;
            toRet = this.history[this.index].data;
        }
        return toRet;
    }
    redo() {
        let toRet = null;
        if (this.index < this.history.length - 1) {
            this.index += 1;
            toRet = this.history[this.index].data;
        }
        return toRet;
    }
}
exports.UndoManager = UndoManager;
//# sourceMappingURL=UndoManager.js.map